import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { FormComponent } from '../../shared/form/form.component';
import { ListComponent } from '../../shared/list/list.component';

@Component({
  selector: 'app-sms-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./sms-list.component.scss', '../../shared/base-list/base-list.component.scss']
})

export class SmsListComponent extends ListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.entity = 'sms';
  }

  getBody() {
    const body = super.getBody();
    if (this.selectedAccount) {
      if (body.query) {
        body.query = [body.query, 'and', ['account_id', '=', this.selectedAccount]];
      } else {
        body.query = ['account_id', '=', this.selectedAccount];
      }
    }
    if (this.selectedAccount) {
      this.columns = this.columns.filter(c => c.name !== 'account_id');
    }
    return body;
  }

  async perform(action, row) {
    if (action.name !== 'BROADCAST') {
      return super.perform(action, row);
    }
    const form = this.activeModal.open(FormComponent, { size: 'md' });
    form.componentInstance.colCount = 1;
    form.componentInstance.title = action.caption;
    form.componentInstance.hiddenApply = true;
    form.componentInstance.hiddenReset = true;
    form.componentInstance.formData = { statuses: ['ACT'] };
    form.componentInstance.fields = [
      {
        name: 'message',
        caption: this.translator.instant('SMS_TEXT'),
        type: { name: 'textarea' },
        rules: [{ type: 'required' }]
      },
      {
        name: 'statuses',
        caption: this.translator.instant('SUBSCRIBER_STATUS'),
        type: {
          name: 'tagbox',
          options: ['ACT', 'EXP', 'REV'].map(s => ({ value: s, name: this.translator.instant(s) }))
        },
        rules: [{ type: 'required' }]
      },
      {
        name: 'expiry_from',
        caption: this.translator.instant('EXPIRY_FROM'),
        type: { name: 'date' },
        rules: []
      },
      {
        name: 'expiry_to',
        caption: this.translator.instant('EXPIRY_TO'),
        type: { name: 'date' },
        rules: []
      }
    ];
    form.componentInstance.done.subscribe(res => {
      const body = {
        message: res.message,
        statuses: res.statuses,
        expiry_from: res.expiry_from,
        expiry_to: res.expiry_to
      };
      form.componentInstance.loading = true;
      // Count first, so whoever presses send sees how many people and how many
      // billed segments they are about to commit to.
      this.service.perform(this.entity, action.name, { ...body, preview: true }).subscribe((preview: any) => {
        form.componentInstance.loading = false;
        if (!preview.count) {
          this.handleWarning(this.translator.instant('BROADCAST_EMPTY'));
          return;
        }
        const dialog = custom({
          title: action.caption,
          messageHtml: this.translator.instant('CONFIRM_BROADCAST', {
            count: preview.count,
            segments: preview.segments,
            total: preview.count * preview.segments
          }),
          buttons: [
            { text: this.translator.instant('YES'), onClick: () => true },
            { text: this.translator.instant('NO'), onClick: () => false }
          ]
        });
        dialog.show().done(confirmed => {
          if (!confirmed) {
            return;
          }
          form.componentInstance.loading = true;
          this.service.perform(this.entity, action.name, body).subscribe((result: any) => {
            form.componentInstance.loading = false;
            form.close();
            this.handleSuccess(this.translator.instant('BROADCAST_QUEUED', { count: result.queued }));
            this.load();
          }, error => {
            form.componentInstance.loading = false;
            this.handleError(error);
          });
        });
      }, error => {
        form.componentInstance.loading = false;
        this.handleError(error);
      });
    });
  }

}
